import { useAccessibleLinkedEntities } from "@common/components/linkedEntityCollapseList/useAccessibleLinkedEntities.ts";
import { useSelectableLegalEntityQuery } from "../../../legalEntity/useSelectableLegalEntityQuery.ts";
import { useLegalEntityLink } from "../../../legalEntity/useLegalEntityLink.ts";
import { ProcessLegalEntitiesFieldProps } from "./ProcessLegalEntitiesField.tsx";

interface AccessibleLegalEntitySubContractors {
    id: string;
    subContractors: Array<string>;
}

export function useProcessLegalEntitiesField(props: ProcessLegalEntitiesFieldProps) {
    const { getLegalEntityLink } = useLegalEntityLink();
    const { isLoading, data } = useSelectableLegalEntityQuery(!props.isPreview);
    const { getAccessibleEntity, isEntityLoading } = useAccessibleLinkedEntities<AccessibleLegalEntitySubContractors>(
        "/legalEntitySubContractor/accessible-details",
        props.legalEntityIds,
        !props.isPreview
    );

    function getLinkTo(id: string) {
        const legalEntity = data?.find((item) => item.id === id);
        return legalEntity && getAccessibleEntity(id) ? getLegalEntityLink(legalEntity) : undefined;
    }

    function getSubContractors(id: string) {
        return getAccessibleEntity(id)?.subContractors;
    }

    return { isLoading, data, getLinkTo, getSubContractors, isSubContractorsLoading: isEntityLoading };
}
